module.exports = __webpack_public_path__ + "h5/img/syzq2.2fb3d756.png";